import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Loading } from "@/components/ui/loading";
import { Pencil } from "lucide-react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/pages/auth/auth.context";

export interface SeniorityLevel {
  id: string;
  level: string;
  hoursOfDelay: number;
  description: string;
}

export default function ManageSeniority() {
  const { data: seniorityLevels, isLoading } = useQuery({
    queryKey: ["seniority"],
    queryFn: async () => {
      const response = await axiosInstance.get<SeniorityLevel[]>("seniority");
      return response.data;
    },
  });

  if (isLoading) return <Loading text="Loading . . ." />;

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold text-foreground mb-8">
        Manage Seniority Levels
      </h1>

      <Card className="mb-6">
        <CardHeader>
          <CardTitle>About Seniority Levels</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            Seniority levels determine the order in which employees are notified
            of new party opportunities. Level 1 employees receive notifications
            first, followed by subsequent levels after their specified delay
            periods.
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Seniority Level Configuration</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {seniorityLevels?.map((level) => (
              <div key={level.level} className="flex items-center gap-4">
                <div className="w-24">
                  <Label>{level.description}</Label>
                </div>
                <div className="flex w-32 ">
                  <div className="flex gap-2">
                    <span className="flex text-left text-muted-foreground">
                      <span className="pr-4 w-10">{level.hoursOfDelay}</span>{" "}
                      hours delay
                    </span>
                  </div>
                </div>
                <Link to={`/admin/seniority/${level.id}/edit`}>
                  <Button variant="outline" size="sm">
                    <Pencil className="h-4 w-4 mr-1" />
                    Edit
                  </Button>
                </Link>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
